import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import { 
  EDIT_PROFILE,
  GET_USER_PROFILE_INFO,
  UPDATE_USER_PROFILE
} from "./actionTypes"
import { 
  profileSuccess, 
  profileError,
  getUserProfileInfoSuccess,
  getUserProfileInfoFail,
  updateUserProfileSuccess,
  updateUserProfileFail
} from "./actions"

//Include Both Helper File with needed methods
import {
  getUserProfileInfo,
  updateUserProfile,
} from "../../../helpers/backend_helper"


function* editProfile({ payload: { user } }) {
  try {
    // Profile editing not implemented - use updateUserProfile instead
    yield put(profileError({ message: "Use profile update functionality instead" }))
  } catch (error) {
    yield put(profileError(error))
  }
}
// Get User Profile Info Saga
function* getUserProfileInfoSaga({ payload: options }) {
  try {
    const response = yield call(getUserProfileInfo, options)
    yield put(getUserProfileInfoSuccess(response))
  } catch (error) {
    yield put(getUserProfileInfoFail(error))
  }
}

// Update User Profile Saga
function* updateUserProfileSaga({ payload: { data, options } }) {
  try {
    const response = yield call(updateUserProfile, data, options)
    yield put(updateUserProfileSuccess("Profile updated successfully"))
  } catch (error) {
    yield put(updateUserProfileFail(error))
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
}

export function* watchGetUserProfileInfo() {
  yield takeEvery(GET_USER_PROFILE_INFO, getUserProfileInfoSaga)
}

export function* watchUpdateUserProfile() {
  yield takeEvery(UPDATE_USER_PROFILE, updateUserProfileSaga)
}

function* ProfileSaga() {
  yield all([
    fork(watchProfile),
    fork(watchGetUserProfileInfo),
    fork(watchUpdateUserProfile)
  ])
}

export default ProfileSaga
